import React from 'react'

export const SectionBody = ({ children }) => <div className='section-body'>{children}</div>